
import { Card, CardContent } from "./ui/card.tsx";
import { Avatar, AvatarImage, AvatarFallback } from "./ui/avatar.tsx";

const TeamsSection = () => {
return (
    <section id="team" className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Warum es das gibt
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Unsere Eltern wohnen weit weg. Jeden Tag anzurufen schaffe ich nicht –
            und nicht anzurufen fühlt sich auch nicht gut an. Aus genau diesem
            Zwiespalt ist esgehtmirgut.ch entstanden: eine kurze Nachricht am
            Morgen, und wir hören nur voneinander, wenn etwas ist.
          </p>
        </div>

        <div className="flex justify-center">
          <Card className="max-w-sm">
            <CardContent className="p-6 text-center">
              <Avatar className="w-24 h-24 mx-auto mb-4">
                <AvatarImage src="img/team/familie.jpg" alt="Gründer" />
                <AvatarFallback className="text-xl font-semibold bg-blue-100 text-blue-600">
                  EG
                </AvatarFallback>
              </Avatar>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Philip Hanke
              </h3>
              <p className="text-blue-600 font-medium mb-3">
                Gründer & Geschäftsführer
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                Meine Frau und ich wohnen mit unserem Sohn in <a href="https://www.stallikon.ch" target="_blank" rel="noreferrer" className="text-blue-600 hover:text-blue-800 underline">Stallikon</a> bei Zürich.
                Meine Mutter lebt in Wien, die Eltern meiner Frau in Cartagena.
                Seit einem Jahr weiss ich dank dieses Dienstes jeden Morgen, dass
                es meiner Mutter gut geht.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TeamsSection;
